module.exports = __webpack_public_path__ + "img/img_body_biz_table_manager_logo.40a8c388.png";